// extracted by mini-css-extract-plugin
module.exports = {"otpContainer":"mfaOtpForm_otpContainer__249O4","otpInput":"mfaOtpForm_otpInput__1QOZ7"};